import type { DomainPermissions } from '../types/app'

/**
 * The customer and job the Sky social dashboards are fixed to, server-side.
 *
 * These MIRROR `goapi/pkg/server/sky_social_media.go`'s `skyCustomer`/`skyJob`,
 * which `ForceRouteScope` pins in code. They are duplicated rather than fetched
 * because the nav has to decide before any request is made — and if they ever
 * drift, the symptom is a visible menu entry leading to a 403, not a data leak:
 * the backend is the authority and does not consult this file.
 */
export const SKY_SOCIAL_CUSTOMER = 'bprsky'
export const SKY_SOCIAL_JOB = 'tiktok'

/**
 * Whether to offer the Social Media nav entry (T6.1).
 *
 * 🔴 THE PERMISSION ALONE IS NOT ENOUGH, and that is the whole ticket.
 * `canAccessSocialMediaPOC` is DOMAIN-derived — true for `bayesprice.com`,
 * `sky.uk` and `sky.ie` — so it is already Sky-only in practice, but it says
 * nothing about the JOB. A Sky user sitting on a non-TikTok job was still shown
 * the tab, and it led to a dashboard scoped to a job they were not looking at.
 *
 * Gating on the customer AND the job matches what the backend already fixes, so
 * the tab appears exactly where it works.
 */
export function canAccessSkySocialMedia(
  permissions: DomainPermissions | null | undefined,
  customer: string | null | undefined,
  job: string | null | undefined,
): boolean {
  if (!permissions?.canAccessSocialMediaPOC) return false
  return (
    (customer ?? '').toLowerCase() === SKY_SOCIAL_CUSTOMER &&
    (job ?? '').toLowerCase() === SKY_SOCIAL_JOB
  )
}
